import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { INumberProps } from './INumberProps'
import clsx from 'clsx'
import { useNumberValidationSchema } from './NumberValidationSchema'

interface ISimpleNumberProps extends HTMLAttributes<HTMLInputElement>, INumberProps { }

export const SimpleNumber: FC<ISimpleNumberProps> = (props) => {
    const { id, placeholder, value: initValue, className, title, readOnly, disabled } = props
    const schema = useNumberValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<number | undefined>(initValue);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value ? Number(event.target.value) : undefined;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <input
            type='number'
            id={id}
            title={title}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            value={value || ''}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
